function setDateFilterType(reportType) {
    switch (reportType) {
        case "Assignment": {
            return "taken";
        }
        case "Company": {
            return "none";
        }
        case "Financial": {
            return "activity";
        }
        case "User": {
            return "none";
        }
        case "License": {
            return "none";
        }
        case "Location": {
            return "none";
        }
        default: {
            return "none";
        }
    }
}
class GenericReport {
    constructor(reportType) {
        this.type = reportType;
        this.filter = {
            date: undefined,
            type: setDateFilterType(reportType)
        };
        this.results = [];
        this.compare = [];
        this.loading = false;
    }
}
export { GenericReport };
